
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { YOUTUBE_PAGE } from '@/components/transcription-landing/landingPages';
import TranscriptionLanding from '@/components/transcription-landing/TranscriptionLanding';
export default function YouTubeTranscriptPage() {
    return <TranscriptionLanding page={YOUTUBE_PAGE}/>;
}

    async function __Next_Translate__getStaticProps__1a167d9f250__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/youtube',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a167d9f250__ as getStaticProps }
  